"use client";

import { Sparkles } from "lucide-react";
import { useIntl } from "react-intl";
import PersonalizedDemoWebsiteForm from "./PersonalizedDemoWebsiteForm";

export default function HomePersonalizedDemoCTA() {
  const intl = useIntl();
  return (
    <div className="mx-auto mt-8 max-w-3xl">
      <div className="rounded-2xl border border-indigo-200/70 bg-white/85 p-3 shadow-xl shadow-indigo-950/10 backdrop-blur sm:p-4">
        <div className="mb-3 flex items-center justify-center gap-2 text-sm font-semibold text-indigo-700">
          <Sparkles className="h-4 w-4" aria-hidden="true" />
          {intl.formatMessage({
            id: "home.personalizedDemo.promise",
            defaultMessage:
              "Create a free chatbot inspired by your website in 10 minutes",
          })}
        </div>
        <PersonalizedDemoWebsiteForm />
        <p className="mt-3 text-xs text-slate-500">
          {intl.formatMessage({
            id: "home.personalizedDemo.reassurance",
            defaultMessage:
              "No card required. Your private preview is ready to review before it can be shared.",
          })}
        </p>
      </div>
    </div>
  );
}

